import { useTranslation } from 'react-i18next';
import OtpCredential from './credentials/OtpCredential';
import { Button, Link, Typography } from '@okta/odyssey-react-mui';
import { ExternalLinkIcon } from '@okta/odyssey-react-mui/icons';
import CommonCredential from './credentials/CommonCredential';
import Expiry from './callouts/Expiry';
const LabComponent = ({ component }) => {
    const { t } = useTranslation();
    
    return (
        <div>
            {component ? (
                <div className='component columnLayout'>
                    <Typography variant='h6'>
                        {component.instanceDetails.label}
                        {component.meta_data.expires_on && <Expiry expiry={component.meta_data.expires_on} />}
                    </Typography>
                    {component.instanceDetails.launchUrl &&
                        <Button
                            variant='tertiary'
                            label={t('launch')}
                            endIcon={<ExternalLinkIcon/>}
                            onClick={() => window.open(component.instanceDetails.launchUrl)}
                            isDisabled={component.state !== "active"}
                        />
                    }
                    {component.instanceDetails.link &&
                    <Button
                        variant='tertiary'
                        label={t('launch')}
                        endIcon={<ExternalLinkIcon/>}
                        onClick={() => window.open(component.instanceDetails.link)}
                        isDisabled={component.state !== "active"}
                    />
                    }

                    {component.instanceDetails.deploymentData && component.instanceDetails.deploymentData.TenantName &&
                        <CommonCredential title='Tenant' value={component.instanceDetails.deploymentData.TenantName}/>
                    }

                    {component.instanceDetails.credentials &&
                        (
                            <div>
                                {component.instanceDetails.credentials.clientId &&
                                    <div >
                                        <CommonCredential title={t('clientId')} value={component.instanceDetails.credentials.clientId}/>
                                        <CommonCredential title={t('clientSecret')} value={component.instanceDetails.credentials.clientSecret}/>
                                        <div><Link href={component.instanceDetails.credentials.discoveryUrl} variant='monochrome' target='_blank'>{t('metadata')} </Link></div>
                                    </div>
                                }
                                {component.instanceDetails.credentials.username &&
                                    <div>
                                        <CommonCredential title={t('username')} value={component.instanceDetails.credentials.username}/>
                                        <CommonCredential title={t('password')} value={component.instanceDetails.credentials.password}/>
                                        {component.instanceDetails.credentials.otpSeed && 
                                            <OtpCredential seed={component.instanceDetails.credentials.otpSeed}/>
                                        }
                                    </div>
                                }
                                {component.instanceDetails.credentials.apiKey &&
                                    <CommonCredential title={t('apiKey')} value={component.instanceDetails.credentials.apiKey}/>
                                }
                                {component.instanceDetails.deploymentData && component.instanceDetails.settings.showDeploymentData &&
                                    <div>
                                        {Object.keys(component.instanceDetails.deploymentData).map((key) => (
                                            <CommonCredential title={key} value={component.instanceDetails.deploymentData[key]}/>
                                        ))}
                                    </div>
                                }
                            </div>
                        )
                    }
                    {component.state === "error" &&
                        <span>{t('componentError')}</span>
                    }
                    {component.state === "queued" &&
                        <span>{t('componentDeploying')}</span>
                    }
                </div>
            )
                : (<div></div>)
            }
        </div>
    )

}
export default LabComponent